import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import routes from '../routes/route';
import { IconType } from '../components/atoms/icon/icon';

export default {
  attributeName: 'appBlackouts',
  isDragable: false,
  canOpen: true,
  canEdit: true,
  canCreate: false,
  canRemove: true,
  createPath: routes.APP_BLACKOUT_NEW,
  editURL: routes.APP_BLACKOUT_EDIT,
  emptyMessage: "There hasn't been a blackout yet.",
  fields: [
    {
      attributeName: 'visibility',
      label: 'Geo-restriction',
      type: FormInputTypes.SELECT,
      helpText: 'Geo-restriction enable/disable for this content.',
      options: [
        { name: 'Enabled', value: 'enabled' },
        { name: 'Disabled', value: 'disabled' },
      ],
      canEdit: true,
      canCreate: false,
      width: '10rem',
    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Name to identify the rule',
      default: '',
      width: '10rem',
      canEdit: false,
      canCreate: false,
      canFilter: false,
      canOrder: false,
    },
    {
      attributeName: 'countryCode',
      label: 'Country',
      type: FormInputTypes.COUNTRY_FLAG,
      helpText: 'Country from the transaction was made',
      default: '',
      width: '10rem',
      canEdit: false,
      canCreate: false,
      canFilter: false,
      canOrder: false,
    },
  
    {
      attributeName: 'postalCodes',
      label: 'Postal Codes',
      type: FormInputTypes.TEXT_INPUT.TEXT_COMMA,
      helpText: 'Postal codes in this rule',
      default: '',
      canEdit: false,
      canCreate: false,
      canFilter: false,
      canOrder: false,
    },
    // {
    //   attributeName: 'action',
    //   label: 'Action',
    //   type: FormInputTypes.SELECT,
    //   helpText: 'Action of the rule.',
    //   options: [
    //     { name: 'Allow', value: 'allow' },
    //     { name: 'Deny', value: 'deny' },
    //   ],
    //   canEdit: true,
    //   canCreate: false,
    //   width: '10rem',
    // },
  ],
};
